import Cookies from 'js-cookie'

const TokenKey = 'syabToken'
// 设置唯一的杜独一无二的key、

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}


const UserKey = 'UserInfo'
// 设置唯一的杜独一无二的key、

export function getUser() {
  return Cookies.get(UserKey)
}

export function setUser(userinfo) {
  return Cookies.set(UserKey, userinfo)
}

export function removeUser() {
  return Cookies.remove(UserKey)
}




// WEBPACK FOOTER //
// ./src/utils/auth.js